// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"45.5\" height=\"45.5\" viewBox=\"0 0 45.5 45.5\"> <path data-name=\"Path 4\" d=\"M0,0V41a4,4,0,0,0,4,4H45\" transform=\"translate(0.5)\" fill=\"none\" stroke=\"#ed0206\" stroke-linejoin=\"round\" stroke-miterlimit=\"10\" stroke-width=\"1\"/> </svg> ";
// Exports
module.exports = code;